// extracted by mini-css-extract-plugin
export default {"hackerNewsCard":"HackerNewsSourceCard_hackerNewsCard__KXmEW"};